module.exports = __webpack_public_path__ + "static/media/fill-receipt-added.8976a468.svg";